import { ajaxAuth } from "@tm/utils"
import { WebserviceUrl } from "../../../webserviceUrls"
import { mapGetAdvertisementResponse } from "./mapper"
import { GetAdvertisementRequest, GetAdvertisementResponse } from "./model"

export function getAdvertisement(body: GetAdvertisementRequest): Promise<GetAdvertisementResponse> {
    const url = `${WebserviceUrl.ErpConnect}/GetAdvertisement`

    return new Promise<GetAdvertisementResponse>((resolve, reject) => {
        ajaxAuth({ url, body, method: "POST" }).then((response) => {
            const result = mapGetAdvertisementResponse(response)
            if (result) {
                resolve(result)
            } else {
                reject()
            }
        }, reject)
    })
}
